import React from "react";
import { showLocalDate } from "../../../utilities/functions";

const ExpireDate = ({ row }) => {
  return <div>{row?.expiryDate ? showLocalDate(row?.expiryDate) : ""}</div>;
};

export default ExpireDate;
